module.exports = __webpack_public_path__ + "img/record_bg.db194ed6.png";